<script setup lang="ts">
import rvapi from "@/rvapi";
import { ref, toRefs } from "vue";
import ArmedButton from "./ArmedButton.vue";

const props = defineProps<{
  orderId: string;
  email: string;
}>();

const { orderId } = toRefs(props);

const emailStr = ref("");
const state = ref("normal");
const receiptResult = ref("");
const arm = () => {
  emailStr.value = props.email;
  state.value = "armed";
};
const resendReceipt = async () => {
  state.value = "sending";
  receiptResult.value = await rvapi.resendReceipt(
    orderId.value,
    emailStr.value.toLocaleLowerCase(),
  );
  state.value = "done";
};
</script>
<template>
  <!-- armed state -->
  <p v-show="state === 'armed'">
    <pn-input
      v-model="emailStr"
      label="Resend receipt to this email"
      helpertext="You can change this, but make sure the recipient is correct."
    />
  </p>

  <!-- normal state -->
  <p v-show="state === 'normal' || state === 'armed'">
    <ArmedButton
      buttonText="Resend receipt to customer"
      armedText="Are you sure?"
      @armed="arm"
      @click="resendReceipt"
    />
  </p>
  <!-- sending state -->
  <pn-spinner size="2" v-show="state === 'sending'" />
  <p v-show="state === 'done'">
    <pn-toast
      v-show="receiptResult === 'ok'"
      closable="false"
      text="Receipt resend successful"
    >
    </pn-toast>
    <pn-toast
      v-show="receiptResult !== 'ok'"
      closable="false"
      appearance="error"
      :text="receiptResult"
    >
    </pn-toast>
  </p>

  <p></p>
</template>
